import { useQuery } from '@tanstack/react-query';
import {
  GetThemePerformance,
  themeOverview,
  V2ThemePerformanceParams,
  V2ThemePerformanceResponse,
} from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

const QUERY_KEY_GET_THEME_PERFORMANCE = 'QUERY_KEY_GET_THEME_PERFORMANCE';

export const useGetThemePerformance = ({
  themeId = '',
}: {
  themeId?: string;
}) =>
  useQuery({
    queryKey: [QUERY_KEY_GET_THEME_PERFORMANCE, themeId],
    queryFn: async ({ signal }) => {
      return await wretchRequest<GetThemePerformance>(
        themeOverview.getThemePerformance.path(themeId),
        {
          schema: themeOverview.getThemePerformance.schema,
          options: { signal },
        }
      );
    },
    enabled: !!themeId,
  });

const QUERY_KEY_GET_V2_THEME_PERFORMANCE = 'QUERY_KEY_GET_V2_THEME_PERFORMANCE';

export const useGetV2ThemePerformance = (params?: V2ThemePerformanceParams) =>
  useQuery({
    queryKey: [QUERY_KEY_GET_V2_THEME_PERFORMANCE, params],
    queryFn: async ({ signal }) => {
      return await wretchRequest<V2ThemePerformanceResponse>(
        themeOverview.getV2ThemePerformance.path(params),
        {
          schema: themeOverview.getV2ThemePerformance.schema,
          options: { signal },
        }
      );
    },
  });
